module.exports = __webpack_public_path__ + "img/Result_Beginner_0608_01.752d418c.png";